import React, {Component, Fragment, useEffect} from 'react';
import NumberFormat from 'react-number-format';
import moment from "moment/moment";
import { toast } from 'react-toastify';
import ReactTooltip from 'react-tooltip';
import Switch from "react-switch";


export default class OverrideRevenueGoal extends Component {
    
    state = {
        showPopulateMonthlyRow: false,
        plannedIncrease: this.props.overridePlProfile.goal_increase,
        plannedRetention: this.props.overridePlProfile.planned_retention,
        disableSaveButton: true,
        plannedIncreaseAmount: parseInt(
            this.props.totalLYRevenue * this.props.overridePlProfile.goal_increase / 100
        ),
        isUpdated: false
    }
    setUpdate = () =>{
        this.setState({isUpdated: !this.state.isUpdated})
    }

    populateMonthlyGoal = () => {
        this.setState({showPopulateMonthlyRow: true});
    };

    handleMonthlyGoalChange = (name, values) => {
        console.log(name);
        const {floatValue} = values;
        this.setState({
            disableSaveButton: false, 
            [name]: floatValue
        });
    };

    changePercentagePlanned = () => {
        let {plannedIncreaseAmount} = this.state;
        const {totalLYRevenue} = this.props;
        let plannedIncrease = 0;
        if (totalLYRevenue) {
            plannedIncrease = plannedIncreaseAmount * 100 / totalLYRevenue
        }
        this.setState({plannedIncrease});
    }

    changePlannedAmount = () => {
        let {plannedIncrease} = this.state;
        const {totalLYRevenue} = this.props;
        let plannedIncreaseAmount = parseInt(totalLYRevenue * plannedIncrease / 100);
        this.setState({plannedIncreaseAmount});
    }

    savePopulateMonthlyGoal = async () => {
        const {plannedIncrease, plannedRetention} = this.state;
        
        if (plannedRetention < 0 || plannedRetention > 100) {
            toast.error('% Planned Retention must be in range [0, 100]');
            return false;
        }
        this.props.saveOverrideRevenueGoal(
            plannedIncrease, plannedRetention, true
        );
    };

    cancelPopulateMonthlyGoal = () => {
        this.setState({showPopulateMonthlyRow: false, plannedIncrease: 0});
    };

    handleChange = (elementClass, values) => {
        const {floatValue} = values;

        if (elementClass) {
            elementClass = elementClass.split('-');
            this.props.handleOverrideRevenueGoalChanges(elementClass, parseInt(floatValue, 10));
            this.setState({disableSaveButton: false});
        }
    };

    saveChange = () => {
        if (!this.state.disableSaveButton) {
            this.props.saveOverrideRevenueGoal(this.state.plannedIncrease, this.state.plannedRetention, true);
        }
    };

    cancelChange = () => {
        this.setState({disableSaveButton: true});
        this.props.cancelOverrideRevenueGoalChanges();
    };

    addClassToButton = () => {
        const {overridePlProfile} = this.props;

        let agencyRevenueGoal = overridePlProfile.override_calculate_goal ? overridePlProfile.total_override_goal : overridePlProfile.total_revenue_goal;

        return (parseInt(overridePlProfile.total_override_goal, 10) !==
            parseInt(agencyRevenueGoal, 10));
    };

    openOverrideGoal = async (e) => {
        if (this.state.isRevenueChanged) {
            this.props.showConfirmModal({
                msgTitle: 'Save / Discard Changes !',
                msgBody: [<p>There are some unsaved changes in Revenue Actual.</p>, 
                    <p>Do you want to save / discard the changes ?</p>
                ],
                buttons: [
                    {
                        label : 'Save',
                        onClick : () => {
                            this.saveRevenue();
                            this.props.getOverrideGoal();
                        },
                        className : 'btn-success'
                    },
                    {
                        label : 'Discard',
                        onClick : () => {
                            this.props.getOverrideGoal();
                        },
                        className : 'btn-danger'
                    },
                    {
                        label : 'Cancel',
                        onClick : () => {},
                        className : 'btn-primary'
                    }
                ]
            });
        } else {
           this.props.getSelectedPlList(e);
           
        }
    };

    render = () => {
        console.log(this.props)
        let plListOption;
        const {plannedIncrease, plannedRetention, plannedIncreaseAmount} = this.state;
        const {overridePlProfile, plProfile, iw} = this.props;

        const today = moment().subtract(1, "month");
        const profileEndDate = plProfile && plProfile.end_date ? moment(plProfile.end_date): today;
        const isOldProfile = profileEndDate < today;
        plListOption = this.props.plList.plList.map((list, index) =>
                <option key={index} value={list.id}>{list.profile}</option>
            );
        
        let agencyRevenueGoal = overridePlProfile.override_calculate_goal ? 
            overridePlProfile.total_override_goal 
            : overridePlProfile.total_revenue_goal;

        let topRevenueRow = [], bottomRevenueRow = [],
            topNewRevenueRow = [], bottomNewRevenueRow = [],
            topTableHeader = [], bottomTableHeader = [],
            topCombinedRevenueRow = [], bottomCombinedRevenueRow = [];

        if (typeof overridePlProfile !== 'undefined' &&
            typeof overridePlProfile.revenue_goals !== 'undefined'
            && overridePlProfile.revenue_goals.length > 0) {

            topTableHeader.push(<th key={-3}>Month</th>);
            topNewRevenueRow.push(<td key={-3}>New</td>);
            topRevenueRow.push(<td key={-3}>Renewal</td>);
            topCombinedRevenueRow.push(<td key={-3}>Revenue</td>);
            bottomTableHeader.push(<th key={-3}>Month</th>);
            bottomNewRevenueRow.push(<td key={-3}>New</td>);
            bottomRevenueRow.push(<td key={-3}>Renewal</td>);
            bottomCombinedRevenueRow.push(<td key={-3}>Revenue</td>);

            overridePlProfile.revenue_goals.map((revenue, index) => {
                if (6 > index) {
                    topTableHeader.push(
                        <th className="text-center" key={"month-" + revenue.id}>
                            <span className="revenue-block">{revenue.month_name}</span>
                        </th>
                    );

                    topNewRevenueRow.push(
                        <td className={"new_goal-" + revenue.id} 
                            key={"new_goal-" + revenue.id}
                        >
                        <NumberFormat type="tel" value={
                            this.state.isUpdated? revenue.updated_new_goal: revenue.new_goal
                                }
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={!this.state.isUpdated} 
                                onValueChange={values => 
                                
                                    {

                                        if(this.state.isUpdated) {

                                            this.handleChange("updated_new_goal-" + revenue.id, values)

                                            return;
                                    }

                                        this.handleChange("new_goal-" + revenue.id, values)

                                    }
                                    
                                }
                                style={{
    border: this.state.isUpdated && revenue.updated_new_goal !== revenue.new_goal? '1px solid red': 'initial' 
    }}
                                className="form-control form-control-sm text-center" 
                                name={"new_goal"} tabIndex={index*2+1} 
                        />
                        {/* { this.state.isUpdated === false ?
                            <NumberFormat type="tel" value={revenue.new_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={false} 
                                onValueChange={(values) => this.handleChange(
                                    "new_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="new_goal" tabIndex={index*2+1} 
                            />
                            :
                            <NumberFormat type="tel" value={revenue.updated_new_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={true} 
                                onValueChange={(values) => this.handleChange(
                                    "new_updated_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="new_updated_goal" tabIndex={index*2+1} 
                            />
                        } */}
                        
                        </td>
                    );
                    topRevenueRow.push(
                        <td className={"renewal_goal-" + revenue.id} 
                            key={"renewal_goal-" + revenue.id}
                        >
                            <NumberFormat type="tel" value={revenue.renewal_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={true} 
                                className="form-control form-control-sm text-center" 
                                name="renewal_goal" tabIndex={(index+1)*2} 
                            />
                        </td>
                    );
                    topCombinedRevenueRow.push(
                        <td className={"combined_goal-" + revenue.id} 
                            key={"combined_goal-" + revenue.id}
                        >
                            <NumberFormat type="tel" value={revenue.combined_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} 
                                onValueChange={(values) => this.handleChange(
                                    "combined_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="combined_goal" tabIndex={(index+1)} 
                            />
                        </td>
                    );
                } else {
                    bottomTableHeader.push(
                        <th className="text-center" key={"month-" + revenue.id}>
                            <span className="revenue-block">{revenue.month_name}</span>
                        </th>
                    );

                    bottomNewRevenueRow.push(
                        <td className={"new_goal-" + revenue.id} 
                            key={"new_goal-" + revenue.id}
                        >
                        <NumberFormat type="tel" value={
                            this.state.isUpdated? revenue.updated_new_goal: revenue.new_goal
                                }
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={!this.state.isUpdated} 
                                onValueChange={values => 
                                
                                    {

                                        if(this.state.isUpdated) {

                                            this.handleChange("updated_new_goal-" + revenue.id, values)

                                            return;
                                    }

                                        this.handleChange("new_goal-" + revenue.id, values)

                                    }
                                    
                                }
                                style={{
    border: this.state.isUpdated && revenue.updated_new_goal !== revenue.new_goal? '1px solid red': 'initial' 
    }}
                                className="form-control form-control-sm text-center" 
                                name={"new_goal"} tabIndex={index*2+1} 
                        />
                        {/* { this.state.isUpdated === false ?
                            <NumberFormat type="tel" value={revenue.new_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={false} 
                                onValueChange={(values) => this.handleChange(
                                    "new_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="new_goal" tabIndex={index*2+1} 
                            />
                            :
                            <NumberFormat type="tel" value={revenue.updated_new_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={true} 
                                onValueChange={(values) => this.handleChange(
                                    "new_updated_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="new_updated_goal" tabIndex={index*2+1} 
                            />
                        } */}
                        </td>
                    );
                    bottomRevenueRow.push(
                        <td className={"renewal_goal-" + revenue.id} 
                            key={"renewal_goal-" + revenue.id}
                        >
                            <NumberFormat type="tel" value={revenue.renewal_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} disabled={true} 
                                className="form-control form-control-sm text-center" 
                                name="renewal_goal" tabIndex={(index+1)*2} 
                            />
                        </td>
                    );
                    bottomCombinedRevenueRow.push(
                        <td className={"combined_goal-" + revenue.id} 
                            key={"combined_goal-" + revenue.id}
                        >
                            <NumberFormat type="tel" value={revenue.combined_goal}  
                                thousandSeparator={true} prefix={'$ '} 
                                allowNegative={false} 
                                onValueChange={(values) => this.handleChange(
                                    "combined_goal-" + revenue.id, values)} 
                                className="form-control form-control-sm text-center" 
                                name="combined_goal" tabIndex={(index+1)} 
                            />
                        </td>
                    );
                }
            });
        }
        return (
            <section className="container-fluid p-0">
                <div className="clearfix"></div>
                <div className={`card ${iw ? 'card-section' : 'border'}`}>
                    <div className={`card-header py-2 ${iw ? 'text-white' : 'bg-light'}`}>
                        <ul className="secondary-menu float-left">
                            <li className="pl-0" onClick={this.props.backToDashboard}>
                                <a className="pl-0"> Back</a>
                            </li>
                            {/* <li onClick={this.populateMonthlyGoal}>
                                <a className="pr-0">Calculate Monthly Goal</a>
                            </li> */}
                        </ul>
                        {!iw && 
                            <div className="text-center">
                                <h5 className="mb-1">
                                    Override Calculated Revenue Goals
                                </h5>
                            </div>
                        }
                    </div>
                    <div className="card-body bg-f5">
                    <div className="date-block border-0 " style={{margin:'10px 0px', }}>
                        <div className="form-group text-left">
                       
                            <select name="plList"
                                disabled={true}
                                className="form-control"
                                onChange={
                                    (event) => this.props.getSelectedPlList(event)}
                                value={this.props.plListProfile}>
                                <option value="">Select P&L Profile</option>
                                {plListOption}
                            </select>
                        </div>
                    </div>
                        <fieldset className="card card-body pt-1">
                            <legend className="mb-0 pb-1" style={{width:"fit-content"}}>
                                <small><small>Calculate Monthly Goal </small></small>
                            </legend>
                            <div className="row">
                            {this.state.isUpdated ?
                            <div className="col-sm-3 text-center">
                                    <label className="mb-0">
                                    % Planned Increase
                                        &nbsp;
                                        <i className="fa fa-info-circle" data-tip
                                            data-for="percent-increase-info"
                                        ></i>
                                    </label>
                                    <NumberFormat type="tel" value={
                                        parseInt(this.props.totalLYRevenue === 0 ? plannedIncreaseAmount :
                                        ((this.props.overridePlProfile.updated_total_override_goal - this.props.totalLYRevenue) / 
                                        this.props.totalLYRevenue) * 100)
                                    }  
                                        thousandSeparator={true} suffix={' %'} 
                                        allowNegative={false} decimalScale={3} 
                                        className="form-control text-center" 
                                        disabled={true}
                                    />
                                </div>: null
                             }

                             {!this.state.isUpdated ?
                                <div className="col-sm-3 text-center">
                                    <label className="mb-0">
                                        % Planned Increase
                                        &nbsp;
                                        <i className="fa fa-info-circle" data-tip
                                            data-for="percent-increase-info"
                                        ></i>
                                        <ReactTooltip className="react-tooltip-class"
                                            id="percent-increase-info"
                                        >
                                            <span>
                                                Planned Increase is the percentage of net 
                                                increase in total commission revenue 
                                                including new and renewal income during the 
                                                {iw ? 'soft rollout ' : 'pl profile '} period.
                                            </span>
                                        </ReactTooltip>
                                    </label>
                                    <NumberFormat type="tel" value={plannedIncrease}  
                                        thousandSeparator={true} suffix={' %'} 
                                        allowNegative={false} decimalScale={3} 
                                        onValueChange={(values) => this.handleMonthlyGoalChange(
                                            "plannedIncrease", values)} 
                                        className="form-control text-center" 
                                        name="plannedIncrease" 
                                        onBlur={this.changePlannedAmount}
                                    />
                                </div>: null
                                }
                                <div className="col-sm-3 text-center">
                                    <label className="mb-0">
                                        Planned Increase
                                        &nbsp;
                                        <i className="fa fa-info-circle" data-tip
                                            data-for="amount-increase-info"
                                        ></i>
                                        <ReactTooltip className="react-tooltip-class"
                                            id="amount-increase-info"
                                        >
                                            <span>
                                                Planned Increase is the amount of net 
                                                increase in total commission revenue 
                                                including new and renewal income during the 
                                                {iw ? 'soft rollout ' : 'pl profile '} period.
                                            </span>
                                        </ReactTooltip>
                                    </label>
                                    {
                                        this.state.isUpdated ?
                                    <NumberFormat type="tel" value={
                                        (this.props.overridePlProfile.updated_total_override_goal - 
                                        this.props.totalLYRevenue)
                                        }  
                                        thousandSeparator={true} prefix={'$ '} 
                                        allowNegative={false} decimalScale={0} 
                                        disabled={this.state.isUpdated? true: false}
                                        className="form-control text-center" 
                                        // name="plannedIncreaseAmount" 
                                    />:
                                    <NumberFormat type="tel" value={
                                        plannedIncreaseAmount
                                        }  
                                        thousandSeparator={true} prefix={'$ '} 
                                        allowNegative={false} decimalScale={0} 
                                        onValueChange={(values) => this.handleMonthlyGoalChange(
                                            "plannedIncreaseAmount", values)} 
                                        className="form-control text-center" 
                                        name="plannedIncreaseAmount" 
                                        onBlur={this.changePercentagePlanned}
                                    />
                                    }
                                </div>
                                <div className="col-sm-3 text-center">
                                    <label className="mb-0">
                                        % Planned Retention
                                        &nbsp;
                                        <i className="fa fa-info-circle" data-tip
                                            data-for="retention-info"
                                        ></i>
                                        <ReactTooltip className="react-tooltip-class"
                                            id="retention-info"
                                        >
                                            <span>
                                                Planned Retention is the percentage of 
                                                current business that is planned to renew 
                                                during the 
                                                {iw ? 'soft rollout' : 'pl profile'} period.
                                            </span>
                                        </ReactTooltip>
                                    </label>
                                    <NumberFormat type="tel" value={plannedRetention}  
                                        thousandSeparator={true} suffix={' %'} 
                                        allowNegative={false} 
                                        onValueChange={(values) => this.handleMonthlyGoalChange(
                                            "plannedRetention", values)} 
                                        className="form-control text-center" 
                                        name="plannedRetention" 
                                    />
                                </div>
                                {/* {!isOldProfile && (
                                        this.props.permission.can_add || 
                                        this.props.permission.can_edit
                                    ) &&
                                    <div className="col-sm-2">
                                        <br/>
                                        <button className="btn btn-success" 
                                            onClick={this.savePopulateMonthlyGoal}
                                        > Save </button>
                                    </div>
                                } */}
                            </div>
                        </fieldset>
                        {!iw && 
                            <div className="card card-body bg-light rounded py-2">
                                <div className="row">
                                    <div className="col-6">
                                        <h5><span>Override Monthly Revenue Goals</span></h5>
                                    </div>
                                    <div className="col-6 text-right">
                                        <button
                                            onClick={() => this.props.updateOverrideGoal()}
                                            className={`btn px-1 ${
                                                overridePlProfile.override_calculate_goal ?
                                                "btn-danger" : "btn-success"}`
                                            }
                                        >
                                            {overridePlProfile.override_calculate_goal ?
                                                "Turn Off Override Goal"
                                                :
                                                "Turn On Override Goal"
                                            }
                                        </button>
                                    </div>
                                </div>
                                <p>
                                    The purpose for overriding average monthly goal 
                                    calculated by Symphony is to more accurately 
                                    align monthly revenue goals with last years 
                                    actual revenue. In order to override the 
                                    calculated monthly goal, click on &nbsp;
                                    <b>Override Calculated Goals</b> then enter a 
                                    goal for each month based on last years actual 
                                    plus the planned percentage increase. 
                                    Management needs to be aware that overriding 
                                    automatic goals for less than the total months in 
                                    the compensation period can result in overpayment 
                                    of staff by the end of the compensation period.
                                </p>
                            </div>
                        }
                        <div className={iw ? "row" : "row r-calculate"}>
                            {iw ? <div className="col-md-3"></div> : null}
                            <div className="col-md-3 text-center">
                                <label className="mb-0">
                                    Total {iw ? "revenue":"Override"} Goal: 
                                </label>
                                <p className={`alert py-1 ${
                                    this.addClassToButton() && !iw ? "bg-danger": "bg-score"
                                    } text-white text-center font-18`}
                                >
                                    <NumberFormat 
                                        value={this.state.isUpdated? overridePlProfile.updated_total_override_goal :overridePlProfile.total_override_goal} 
                                        displayType={'text'} 
                                        thousandSeparator={true} prefix={'$ '} 
                                        className="font-weight-bold" 
                                    />
                                </p>
                            </div>
                            <div className="col-md-3 text-center">
                                <label className="mb-0">
                                    {iw ? "":"Override"} Average Monthly Goal
                                </label>
                                <p className={`alert py-1 ${
                                    this.addClassToButton() && !iw ? "bg-danger": "bg-score"
                                    } text-white text-center font-18`}
                                >
                                    <NumberFormat displayType={'text'} 
                                        value={
                                            overridePlProfile.no_of_months > 0 ? 
                                                Math.round(this.state.isUpdated? overridePlProfile.updated_total_override_goal / overridePlProfile.no_of_months :overridePlProfile.total_override_goal / overridePlProfile.no_of_months) 
                                                : 0
                                            } 
                                        thousandSeparator={true} prefix={'$ '} 
                                        className="font-weight-bold" 
                                    />
                                </p>
                            </div>
                            {iw ? null : <Fragment>
                                {/* <div className="col-md-3 text-center">
                                    <label className="mb-0">Agency Revenue Goal:</label>
                                    <p className="alert bg-light py-1 text-center border-score font-18">
                                        <NumberFormat value={agencyRevenueGoal} 
                                            displayType={'text'} 
                                            thousandSeparator={true} prefix={'$ '} 
                                            className="font-weight-bold" 
                                        />
                                    </p>
                                </div> */}
                                {/* <div className="col-md-3 text-center">
                                    <label className="mb-0">Agency Average Monthly Goal</label>
                                    <p className="alert bg-light py-1 text-center border-score font-18">
                                        <NumberFormat 
                                            value={overridePlProfile.no_of_months > 0 ? 
                                                Math.round(agencyRevenueGoal / overridePlProfile.no_of_months) 
                                                : 0
                                            } displayType={'text'} thousandSeparator={true} 
                                            prefix={'$ '} 
                                            className="font-weight-bold" 
                                        />
                                    </p>
                                </div> */}
                                </Fragment>
                            }
                        </div>

                        <div className="col-sm-5 text-center" style={{display:"flex", paddingLeft:7}}>
                            <label className="mb-1 mr-2">
                                {/* {this.state.isUpdated? 
                                "Calculate goals based on Planned % Increase and % Retention":
                                "Manually Adjust New Business Goals"} */}
                                "Manually Adjust New Business Goals"
                            </label>
                            <br/>
                            <Switch
                            className="form-control" 
                            onChange={() => this.setUpdate()}
                            value={this.state.isUpdated}
                            checked={this.state.isUpdated}
                            className="react-switch"
                            height={22}
                            width={44}
                            />
                        </div>

                        <div className="revenue-container">
                            <div className="table-responsive revenue-table">
                                <table>
                                    <thead>
                                        <tr>{topTableHeader}</tr>
                                    </thead>
                                    <tbody>
                                        <tr>{topNewRevenueRow}</tr>
                                        <tr>{topRevenueRow}</tr>
                                    </tbody>
                                </table>
                            </div>
                            {(typeof overridePlProfile.revenue_goals !== "undefined" &&
                                overridePlProfile.revenue_goals.length &&
                                (overridePlProfile.revenue_goals.length) > 6) ?
                                    <div className="table-responsive revenue-table r-table-2">
                                        <table>
                                            <thead>
                                                <tr>{bottomTableHeader}</tr>
                                            </thead>
                                            <tbody>
                                                <tr>{bottomNewRevenueRow}</tr>
                                                <tr>{bottomRevenueRow}</tr>
                                            </tbody>
                                        </table>
                                    </div>
                                :
                                    ""
                            }
                        </div>
                    </div>
                    <div className="card-footer text-right py-1">
                    {/* {console.log(!isOldProfile && (
                            this.props.permission.can_add || this.props.permission.can_edit
                        ))}  */}
                        {!isOldProfile && (
                            this.props.permission.can_add || this.props.permission.can_edit
                        ) &&
                            <button type="button" className="btn btn-success" 
                                onClick={this.saveChange} tabIndex={25}
                            > Save </button>
                        }
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" className="btn btn-warning" 
                            onClick={this.cancelChange} tabIndex={26}
                        > Cancel </button>
                        &nbsp;&nbsp;&nbsp;
                        <button type="button" className="btn btn-info" 
                            onClick={this.props.backToDashboard} tabIndex={27}
                        > Back </button>
                    </div>
                </div>
            </section>
        );
    };
}


// WEBPACK FOOTER //
// ./src/components/agencyRevenue/OverrideRevenueGoal.js